import React from 'react';

const variants = {
  success: {
    border: 'border-l-success',
    bg: 'bg-success-bg',
    icon: 'fas fa-check-circle text-success',
  },
  warning: {
    border: 'border-l-warning',
    bg: 'bg-warning-bg',
    icon: 'fas fa-exclamation-triangle text-warning',
  },
  danger: {
    border: 'border-l-danger',
    bg: 'bg-danger-bg',
    icon: 'fas fa-exclamation-circle text-danger',
  },
  info: {
    border: 'border-l-info',
    bg: 'bg-info-bg',
    icon: 'fas fa-info-circle text-info',
  },
};

export function Alert({ variant = 'info', title, children, action, className = '' }) {
  const v = variants[variant] || variants.info;
  return (
    <div
      className={`border border-prodia-border border-l-4 ${v.border} ${v.bg} rounded-xl p-4 ${className}`}
      role="alert"
    >
      <div className="flex items-start gap-3">
        <i className={`${v.icon} mt-0.5 flex-shrink-0`} aria-hidden="true" />
        <div className="flex-1 min-w-0">
          {title && <p className="text-sm font-semibold text-prodia-text-primary">{title}</p>}
          {children && (
            <div className={`text-sm text-prodia-text-secondary ${title ? 'mt-1' : ''}`}>{children}</div>
          )}
        </div>
        {action && <div className="flex-shrink-0">{action}</div>}
      </div>
    </div>
  );
}

export default Alert;
